import {
  Card,
  CardContent,
  Chip,
  Modal,
  Typography,
  Button,
  Box,
  TextField,
  InputLabel,
} from "@mui/material";

import React, { useState } from "react";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";

const DisputeCard = ({ dispute, getDisputes }) => {
  const [selectedDispute, setSelectedDispute] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [evidence, setEvidence] = useState({
    customer_email_address: "",
    customer_name: "",
    product_description: "",
    billing_address: "",
    customer_purchase_ip: "",
    customer_signature: "",
    receipt: "",
    service_date: "",
    service_documentation: "",
    shipping_address: "",
    shipping_date: "",
    shipping_carrier: "",
    shipping_tracking_number: "",
    shipping_documentation: "",
    uncategorized_text: "",
    cancellation_policy: "",
    cancellation_policy_disclosure: "",
    cancellation_rebuttal: "",
    refund_policy: "",
    refund_policy_disclosure: "",
    refund_refusal_explanation: "",
    duplicate_charge_documentation: "",
    duplicate_charge_explanation: "",
    duplicate_charge_id: "",
  });

  const [uncategorizedFile, setUncategorizedFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleChange = (e) => {
    setEvidence({ ...evidence, [e.target.name]: e.target.value });
  };

  const openEvidenceModal = (dispute) => {
    setSelectedDispute(dispute);
    setModalOpen(true);
  };

  const closeEvidenceModal = () => {
    setModalOpen(false);
    setSelectedDispute(null);
    setUncategorizedFile(null);
  };

  const handleSubmit = async () => {
    setErrors([]);
    setSubmitting(true);

    const formData = new FormData();
    formData.append("disputeId", selectedDispute.id);
    Object.entries(evidence).forEach(([key, value]) => {
      formData.append(`evidence[${key}]`, value);
    });
    if (uncategorizedFile) {
      formData.append("uncategorized_file", uncategorizedFile);
    }

    const response = await callBackendApi("stripe/disputes/respond", "POST", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.success) {
      alert("Evidence submitted successfully!");
      closeEvidenceModal();
      getDisputes();
    } else {
      console.log(response);
      setErrors(response.error);
      alert("Error submitting evidence.");
    }

    setSubmitting(false);
  };

  return (
    <Card>
      <CardContent>
        <p>
          <strong>Dispute ID:</strong> {dispute.id}
        </p>
        <p>
          <strong>Status:</strong> {RenderStatusChip(dispute.status)}
        </p>
        <p>
          <strong>Reason:</strong> {dispute.reason}
        </p>
        <p>
          <strong>Amount:</strong> €{(dispute.amount / 100).toFixed(2)}
        </p>
        <p>
          <strong>Customer:</strong> {dispute.evidence.customer_name || "N/A"} (
          {dispute.evidence.customer_email_address || "N/A"})
        </p>
        <p>
          <strong>Created At:</strong> {new Date(dispute.created * 1000).toLocaleString()}
        </p>
        <p>
          <strong>Respond By:</strong> {new Date(dispute.evidence_details.due_by * 1000).toLocaleDateString()}
        </p>
        <p>
          <strong>Charge:</strong> {dispute.charge}
        </p>
        <p>
          <strong>Payment Method:</strong> {dispute.payment_method_details.type} ({dispute.payment_method_details.card.brand})
        </p>
        <Button
          variant="outlined"
          size="small"
          onClick={() => openEvidenceModal(dispute)}
          sx={{ mt: 2 }}
        >
          View Evidence
        </Button>
      </CardContent>

      <Modal open={modalOpen} onClose={closeEvidenceModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          {selectedDispute && (
            <>
              <Typography variant="h6" gutterBottom>
                Submit Evidence for {selectedDispute.id}
              </Typography>

              {Object.entries(evidence).map(([key, value]) => (
                <TextField
                  key={key}
                  placeholder={key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                  name={key}
                  value={value}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
                  multiline
                  rows={2}
                  error={errors[`evidence.${key}`] !== undefined}
                  helperText={errors[`evidence.${key}`]?.[0] || ""}
                />
              ))}

              <InputLabel sx={{ mt: 2 }}>Attach File (optional)</InputLabel>
              <input
                type="file"
                name="uncategorized_file"
                onChange={(e) => setUncategorizedFile(e.target.files[0])}
                style={{ marginBottom: "1rem" }}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={submitting}
                sx={{ mt: 2 }}
              >
                {submitting ? "Submitting..." : "Submit Response"}
              </Button>
            </>
          )}
        </Box>
      </Modal>
    </Card>
  );
};

const RenderStatusChip = (status) => {
  const statusMap = {
    needs_response: { label: "Needs Response", color: "warning" },
    under_review: { label: "Under Review", color: "info" },
    won: { label: "Won", color: "success" },
    lost: { label: "Lost", color: "error" },
    warning_closed: { label: "Warning Closed", color: "default" },
  };

  const { label, color } = statusMap[status] || {
    label: status,
    color: "default",
  };

  return <Chip label={label} color={color} size="small" />;
};

export default DisputeCard;
